'use client';

import { useEffect } from 'react';
import { get } from '@alltrails/core/utils/get';
import type { TrailId } from '@alltrails/types/TrailId';
import useUser from '@alltrails/context/hooks/useUser';
import { pageViewLimit, PageViewLimit } from '@alltrails/trails';
import logError from '@alltrails/core/utils/logError';
import ScrollLimit from '@alltrails/user-auth/components/ScrollLimit/ScrollLimit';
import { useAppDispatch, useAppSelector } from '@/utils/redux';
import { setViewLimitReached } from '@/utils/trailPageSlice';

type ViewLimitHandlerProps = {
  pageReferer: string | null;
  trailId: TrailId;
  isScrollLimitActive?: boolean;
};

const ViewLimitHandler = ({ pageReferer, trailId, isScrollLimitActive }: ViewLimitHandlerProps) => {
  const user = useUser();
  const dispatch = useAppDispatch();
  const limitReached = useAppSelector(state => state.trailPage.viewLimitReached);

  useEffect(() => {
    const setViewLimit = async () => {
      if (user) {
        return;
      }

      try {
        const { limitReached } = await get<{ limitReached: boolean }>(`/api/mugen/update-view-limit`, {
          headers: {
            ...(!!pageReferer ? { 'X-Page-Referer': pageReferer } : {})
            // header to always show reg wall when referred from an external site
            // { 'X-External-Wall': true }
          }
        });
        dispatch(setViewLimitReached(limitReached));
      } catch (e: any) {
        logError(e);
      }
    };

    setViewLimit();
  }, [user]);

  return isScrollLimitActive ? (
    <ScrollLimit deeplinkData={{ pageType: 'trail', pageId: trailId }} />
  ) : (
    <PageViewLimit limit={pageViewLimit} limitReached={limitReached === 'uninitialized' ? false : limitReached} trailId={trailId} />
  );
};

export default ViewLimitHandler;
